import React from 'react';

import { FlexJustify, FlexLeft } from "common/fragments/Flex";
import Loading from 'common/fragments/Loading';
import { BlockVariant, BlockView } from "common/views/block/BlockView.view";
import { ButtonVariant, ButtonView } from 'common/views/button/Button.view';
import HeadingView, { HeadingVariant } from "common/views/heading/Heading.view";
import IconView from 'common/views/icon/Icon.view';
import { ImageVariant, ImageView } from "common/views/image/Image.view";
import PageLinkView from "common/views/pageLink/PageLink.view";
import { Query } from "core/api/typedQuery";
import { IPanelProps, Panel } from 'core/decorators/Panel';
import { iDef } from "core/util/TypeUtils";
import Config from './Config';
import UserSummary from './entities/UserSummary';
import labelProvider from "./UserSummary.labels";

const { Labels } = labelProvider;

const UserSummaryQuery = Query.queryOne<UserSummary, any>(UserSummary);

@Panel({id: "usersummary", configClass: Config, labelProvider})
export class UserSummaryPanel extends React.PureComponent<IPanelProps<Config>> {

	public render() {
		return (
			<BlockView variant={BlockVariant.JUMBOTRON} viewKey="block">
				<UserSummaryQuery params={{}}>
					{
						({data, loading}) => {
							if (loading) {
								return <Loading />;
							}

							if (!data) {
								return null;
							}

							const { config } = this.props;

							const {
								avatarURL,
								certificatesCount,
								lastLaunched,
								user
							} = data;

							const aUrl = iDef(avatarURL) ? avatarURL : config.defaultAvatarUrl;

							const avatar = (config.showAvatar && aUrl) && (
								<ImageView variant={ImageVariant.AVATAR} viewKey="avatar" src={aUrl} />
							);

							const userDetail = config.showUserDetails && user && (
								<div>
									<HeadingView variant={HeadingVariant.H5} viewKey="subtitle">
										<Labels.Welcome args={{user: `${user.firstName} ${user.lastName}`}} />
									</HeadingView>
								</div>
							);

							const lastLogin = (config.showLastLogin && user && user.lastLoginDate) && (
								<BlockView viewKey="last-login">
									<Labels.LastLogin args={{date: user.lastLoginDate ? new Date(user.lastLoginDate) : undefined}} />
								</BlockView>
							);

							const certificatesEarned = config.showCertificates && (
								<PageLinkView viewKey="certificates-link">
									<ButtonView variant={ButtonVariant.PRIMARY} viewKey="certificates-button">
										<IconView icon="bookmark" viewKey="certificates-button.icon">
											<Labels.Certificates args={{count: (certificatesCount || 0).toString()}} />
										</IconView>
									</ButtonView>
								</PageLinkView>
							);

							const lastLaunchedLink = (config.showLastLaunched && lastLaunched && lastLaunched.launchURL) && (
								<ButtonView variant={ButtonVariant.PRIMARY} viewKey="last-launched-button" onClick={() => window.open(lastLaunched.launchURL.launchURL, '_blank')}>
									<Labels.LastLaunched />
								</ButtonView>
							);

							return (
								<FlexJustify>
									<FlexLeft>
										{avatar}
										{userDetail}
									</FlexLeft>
									<div>
										<FlexJustify>
											{lastLogin}
											{certificatesEarned}
											{lastLaunchedLink}
										</FlexJustify>
									</div>
								</FlexJustify>
							);
						}
					}
				</UserSummaryQuery>
			</BlockView>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/userSummary/UserSummary.panel.tsx